import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { config } from '../../function/config'
import { toast } from 'react-toastify'
import ManagerHeader from './ManagerHeader'

export default function EditAllocatedBed() {

    const { id } = useParams()
    const navigate = useNavigate()
    const token = localStorage.getItem('token')

    const [loading, setLoading] = useState(false)

    const [beds, setBeds] = useState([])
    const [newAdmissions, setNewAdmissions] = useState([])
    const [allocatedBedList, setAllocatedBedList] = useState([])
    const [allocatedBed, setAllocatedBed] = useState(null)

    const [formData, setFormData] = useState({
        bed: '',
        name: '',
        category: ''
    })

    const [errors, setErrors] = useState({
        bed: '',
        name: '',
        category: ''
    })

    const fetchBeds = async () => {
        try {
            const res = await axios.get(`${config.baseurl}get_all_beds/`,{
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${token}`
                }
            })
            console.log('All Beds:', res.data)

            if (res.status === 200) {
                const data = res.data.data || []
                setBeds(data)
                return data
            }

            toast.error('Failed to fetch beds')
            return []
        } catch (error) {

            console.error('Fetch Beds Error:', error.response?.data || error)

            const message =
                error.response?.data?.message ||
                error.response?.data?.error ||
                'Failed to fetch beds'

            toast.error(message)
            return []
        }
    }

    const fetchNewAdmissions = async () => {
        try {
            const res = await axios.get(`${config.baseurl}get_unallocated_admissions/?allocation_id=${id}`,{
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${token}`
                }
            })
            console.log('All New Admissions:', res.data)

            if (res.status === 200) {
                const data = res.data.data || []
                setNewAdmissions(data)
                return data
            }

            toast.error('Failed to fetch New Admissions')
            return []
        } catch (error) {
            console.error('Fetch New Admissions Error:', error.response?.data || error)

            const message =
                error.response?.data?.message ||
                error.response?.data?.error ||
                'Failed to fetch New Admissions'

            toast.error(message)
            return []
        }
    }

    const fetchAllocatedBed = async (bedsList = []) => {
        try {
            const res = await axios.get(`${config.baseurl}get_allocated_beds/`,{
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${token}`
                }
            })
            console.log('All Allocated Beds:',res.data)

            if (res.status !== 200) {
                toast.error('Failed to fetch allocated bed')
                return
            }

            const data = res.data.data || []
            setAllocatedBedList(data)

            const selectedAllocatedBed = data.find((item) => String(item.id) === String(id))
            console.log('Selected Allocated Bed:', selectedAllocatedBed)

            if (!selectedAllocatedBed) {
                toast.error('Allocated Bed Not Found')
                navigate('/manager/all_allocate_bed')
                return
            }

            setAllocatedBed(selectedAllocatedBed)

            let bedValue = ''

            if (selectedAllocatedBed.bed && typeof selectedAllocatedBed.bed === 'object' && selectedAllocatedBed.bed.id) {
                bedValue = String(selectedAllocatedBed.bed.id)
            }else if (selectedAllocatedBed.bed_id) {
                bedValue = String(selectedAllocatedBed.bed_id)
            }else if (selectedAllocatedBed.bed && typeof selectedAllocatedBed.bed !== 'object') {
                bedValue = String(selectedAllocatedBed.bed)
            }
            console.log('Existing Bed ID:',bedValue)

            const selectedBed = bedsList.find((bed) => String(bed.id) === String(bedValue))

            console.log('Selected Bed From Bed List:', selectedBed)

            const categoryValue =
                selectedBed?.bed_type ||
                selectedAllocatedBed.category ||
                (
                    selectedAllocatedBed.bed &&
                    typeof selectedAllocatedBed.bed === 'object'
                        ? selectedAllocatedBed.bed.bed_type
                        : ''
                ) ||
                ''

            console.log('Existing Category:',categoryValue)

            let nameValue = ''

            if (selectedAllocatedBed.name &&  typeof selectedAllocatedBed.name === 'object' && selectedAllocatedBed.name.id) {
                nameValue = String(selectedAllocatedBed.name.id)
            }else if (selectedAllocatedBed.name_id) {
                nameValue = String(selectedAllocatedBed.name_id)
            } else if (selectedAllocatedBed.new_admission_id) {
                nameValue = String(selectedAllocatedBed.new_admission_id)
            } else if (selectedAllocatedBed.name && typeof selectedAllocatedBed.name !== 'object') {
                nameValue = String(selectedAllocatedBed.name)
            }
            console.log('Existing Admission ID:', nameValue)

            setFormData({
                bed: bedValue,
                category: categoryValue,
                name: nameValue
            })
        } catch (error) {
            console.error('Fetch Allocated Bed Error:', error.response?.data || error)

            const message =
                error.response?.data?.message ||
                error.response?.data?.error ||
                'Failed to fetch allocated bed'

            toast.error(message)
        }
    }

    useEffect(() => {
        if (!id) {
            return
        }

        const loadData = async () => {
            const bedsList = await fetchBeds()
            await fetchNewAdmissions()
            await fetchAllocatedBed(bedsList)
        }
        loadData()
    }, [id, token])

    const handleChange = (e) => {
        const { name, value } = e.target

        // Category changed
        if (name === 'category') {
            setFormData({
                category: value,
                bed: '',
                name: ''
            })

            setErrors({
                category: '',
                bed: '',
                name: ''
            })

            return
        }

        // Bed changed
        if (name === 'bed') {
            const selectedBed = beds.find(
                (bed) => String(bed.id) === String(value)
            )

            const selectedCategory = selectedBed?.bed_type || ''

            setFormData((prev) => ({
                ...prev,
                bed: value,
                category: selectedCategory,
                name: ''
            }))

            setErrors((prev) => ({
                ...prev,
                bed: '',
                category: '',
                name: ''
            }))

            return
        }

        // New admission changed
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }))

        setErrors((prev) => ({
            ...prev,
            [name]: ''
        }))
    }

    const validateForm = (data) => {
        const newErrors = {}

        if (!String(data.bed || '').trim()) {
            newErrors.bed = 'Please Select Bed'
        }

        if (!String(data.category || '').trim()) {
            newErrors.category = 'Please Select Category'
        }

        if (!String(data.name || '').trim()) {
            newErrors.name = 'Please Select New Admission'
        }

        return newErrors
    }

    const filteredBeds = beds.filter((bed) => {
        const selectedCategory = String(formData.category || '')
            .trim()
            .toLowerCase()

        const bedCategory = String(bed.bed_type || '')
            .trim()
            .toLowerCase()

        if (!selectedCategory || !bedCategory) {
            return false
        }

        // Bed category must match selected category
        if (bedCategory !== selectedCategory) {
            return false
        }

        // Always show the currently selected bed while editing
        if (String(bed.id) === String(formData.bed)) {
            return true
        }

        // Hide beds already allocated to another admission
        const isAlreadyAllocated = allocatedBedList.some((allocated) => {
            let allocatedBedId = ''

            if (
                allocated.bed &&
                typeof allocated.bed === 'object'
            ) {
            allocatedBedId = allocated.bed.id
            } else if (allocated.bed_id) {
                allocatedBedId = allocated.bed_id
            } else if (allocated.bed) {
                allocatedBedId = allocated.bed
            }

            return String(allocatedBedId) === String(bed.id)
        })

        return !isAlreadyAllocated
    })

    const filteredAdmissions = newAdmissions.filter((admission) => {
        const selectedCategory = String(formData.category || '')
            .trim()
            .toLowerCase()

        const admissionCategory = String(admission.category || '')
            .trim()
            .toLowerCase()

        if (!selectedCategory || !admissionCategory) {
            return false
        }

        return admissionCategory === selectedCategory
    })

    const handleSubmit = async (e) => {

        e.preventDefault()

        const validationErrors =validateForm(formData)

        setErrors(validationErrors)


        if (Object.keys(validationErrors).length > 0) {
            return
        }

        setLoading(true)

        try {
            const payload = {
                bed: Number(formData.bed),
                category:formData.category.trim(),
                name: Number(formData.name)
            }

            console.log('Updating Allocated Bed ID:',id)
            console.log('Update Payload:',payload)

            const res = await axios.put(`${config.baseurl}update_alloted_bed/${id}/`, payload, {
                headers: {
                    'Content-Type':'application/json',
                    'Authorization':`Token ${token}`
                }
            })
            console.log('Update Response:', res.data)

            if (
                res.status === 200 ||
                res.status === 201
            ) {
                toast.success(
                    res.data?.message ||
                    'Allocated Bed Updated Successfully'
                )
                navigate(-1)
            } else {
                toast.error(
                    res.data?.message ||
                    'Failed to update allocated bed'
                )
            }
        } catch (error) {
            console.error(
                'Update Allocated Bed Error:',
                error.response?.data ||
                error
            )

            const responseData = error.response?.data

            let message ='Failed to update allocated bed'

            if (responseData?.message) {
                message = responseData.message
            } else if (responseData?.error) {
                message = responseData.error
            } else if (responseData?.detail) {
                message = responseData.detail
            }
            toast.error(message)
        } finally {
            setLoading(false)
        }
    }

    const inputClass =
        'w-full rounded-xl border border-slate-300 bg-white px-4 py-3 text-sm text-slate-800 outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100 placeholder:text-slate-400'

    return (
        <div className=" min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 ml-64  5xl:ml-0">
            <ManagerHeader />

            <div className="max-w-7xl mx-auto px-6 pt-16 pb-6">
                <div className=" items-center justify-between text-center">

                    <h1 className="mt-1 text-3xl font-bold text-slate-800">Edit Allocated Bed</h1>
                    <p className="mt-2 text-sm text-slate-500">
                        Change the allocated bed
                        for a new admission.
                    </p>
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-6 pb-12">
                <div className=" mx-auto max-w-5xl overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-lg">
                    <div className="border-b border-slate-200 bg-slate-50 px-6 py-5 text-center">
                        <h2 className=" text-lg font-bold text-slate-800">
                            Edit Allocated Bed
                        </h2>
                    </div>

                    <form onSubmit={handleSubmit} className="p-6 md:p-8">
                        <div className=" grid grid-cols-1 gap-6 md:grid-cols-2">
              
                            {/* Category */}
                            <div className="md:col-span-2">
                                <label
                                htmlFor="Category"
                                className="mb-2 block text-sm font-semibold text-slate-700"
                                >
                                Category
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                                </label>

                                <select
                                id="category"
                                name="category"
                                value={formData.category}
                                onChange={handleChange}
                                className={`${inputClass} ${errors.category
                                    ? 'border-red-500 focus:border-red-600'
                                    : ''
                                }`}
                                >
                                <option value="">Select Caegory</option>
                                <option value="Child">Child</option>
                                <option value="Aged Person">Aged Person</option>
                                </select>

                                {errors.category && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.category}</p>
                                )}
                            </div>

                            {/* Bed Number */}
                            <div className="md:col-span-2">
                                <label
                                htmlFor="bed"
                                className="mb-2 block text-sm font-semibold text-slate-700"
                                >
                                Bed
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                                </label>

                                <select
                                id='bed'
                                name='bed'
                                value={formData.bed}
                                onChange={handleChange}
                                disabled={!formData.category}
                                className={`${inputClass} ${
                                    errors.bed ? 'border-red-500 focus:border-red-600' : ''
                                } ${
                                    !formData.category ? 'cursor-not-allowed bg-slate-100' : ''
                                }`}
                                >
                                <option value="">
                                    {!formData.category 
                                    ? 'Select Category first' 
                                    : filteredBeds.length === 0
                                        ? 'No Beds Available'
                                        :'Select Bed'
                                    }
                                </option>
                                {filteredBeds.map((bed) => (
                                    <option key={bed.id} value={bed.id}>
                                    {bed.bed_no}
                                    </option>
                                ))}
                                </select>

                                {errors.bed && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.bed}</p>
                                )}
                            </div>

                            {/* name */}
                            <div className="md:col-span-2">
                                <label
                                htmlFor="name"
                                className="mb-2 block text-sm font-semibold text-slate-700"
                                >
                                New Admission
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                                </label>

                                <select
                                id="name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                disabled={!formData.category}
                                className={`${inputClass} ${
                                    errors.name ? 'border-red-500 focus:border-red-600' : ''
                                } ${
                                    !formData.category ? 'cursor-not-allowed bg-slate-100' : ''
                                }`}
                                >
                                <option value="">
                                    {!formData.category 
                                    ? 'Select Category first' 
                                    : filteredAdmissions.length === 0
                                        ? 'No New Admissions Available'
                                        :'Select New Admission'
                                    }
                                </option>
                                {filteredAdmissions.map((admission) => (
                                    <option
                                    key={admission.id}
                                    value={admission.id}
                                    >
                                    {admission.first_name}{' '}{admission.last_name}
                                    </option>
                                ))}
                                </select>

                                {errors.name && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.name}</p>
                                )}
                            </div>
                        </div>

                        <div className="mt-8 flex flex-row justify-end gap-3 border-t border-slate-200 pt-6 2xl:flex-col-reverse">
                            <button
                                type="button"
                                onClick={() => navigate(-1)}
                                disabled={loading}
                                className="rounded-xl bg-slate-100 px-6 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-200 disabled:cursor-not-allowed disabled:opacity-50"
                            >
                                Cancel
                            </button>


                            <button
                                type="submit"
                                disabled={loading}
                                className="rounded-xl bg-[#000435] px-7 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-[#000326] disabled:cursor-not-allowed disabled:opacity-50"
                            >
                                {loading ? 'Updating...' : 'Update'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}